import { Link } from "react-router-dom";
import { ListRowsSkeleton } from "@/components/skeleton/ListRowsSkeleton";
import type { LowStockAlert } from "@/core/pharmacy/dashboard-analytics";
import { routes } from "@/router/all_routes";

interface LowStockAlertsPanelProps {
  alerts: LowStockAlert[];
  loading: boolean;
  offline: boolean;
  maxItems?: number;
}

export function LowStockAlertsPanel({
  alerts,
  loading,
  offline,
  maxItems = 8,
}: LowStockAlertsPanelProps) {
  return (
    <div className="ph-low-stock-panel">
      <div className="ph-dash-card-head mb-3">
        <div>
          <h3 className="ph-dash-card-title">Alertes stock bas</h3>
          <p className="ph-dash-card-sub">
            Articles sous le seuil minimum (article ou global ISC).
          </p>
        </div>
        <Link to={routes.supplyLevels} className="btn btn-sm ph-btn-outline">
          Voir les niveaux
        </Link>
      </div>

      {loading ? (
        <ListRowsSkeleton rows={maxItems} />
      ) : offline ? (
        <p className="text-warning small mb-0">
          API stock hors ligne — alertes indisponibles.
        </p>
      ) : alerts.length === 0 ? (
        <p className="text-muted small mb-0">Aucune alerte — stocks au-dessus des seuils.</p>
      ) : (
        <ul className="ph-low-stock-list">
          {alerts.slice(0, maxItems).map((alert) => (
            <li key={alert.productId} className="ph-low-stock-item">
              <div>
                <span className="ph-low-stock-label">{alert.label}</span>
                <span className="ph-low-stock-sku text-muted">{alert.sku}</span>
              </div>
              <span className="ph-low-stock-qty">
                {alert.quantity}
                <span className="text-muted"> / {alert.minThreshold}</span>
              </span>
            </li>
          ))}
        </ul>
      )}
      {!loading && alerts.length > maxItems && (
        <p className="text-muted small mt-2 mb-0">
          + {alerts.length - maxItems} autre(s) article(s) sous seuil.
        </p>
      )}
    </div>
  );
}
